import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=2608efb0&lang=pug"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2608efb0')) {
      api.createRecord('2608efb0', component.options)
    } else {
      api.reload('2608efb0', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=2608efb0&lang=pug", function () {
      api.rerender('2608efb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/configuration/Settings.vue"
export default component.exports